var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { getPlatformTag } from 'app/views/components/dialogs/publish/platform';
import { analytics } from 'app/utils/analytics';
import { hasBroadcastChannel } from 'app/utils/caniuse';
import { publishSlice } from '../publish';
import { BroadcastChannel as BroadcastChannelPolyfill } from './polyfill/BroadcastChannel';
const getChannel = (name) => {
    if (hasBroadcastChannel()) {
        return new BroadcastChannel(name);
    }
    return new BroadcastChannelPolyfill(name);
};
export const createPlatformAuthorizationMiddleware = () => store => {
    const broadcast = getChannel('platform:authorization');
    broadcast.onmessage = (message) => {
        const { data, origin } = message;
        try {
            const { platform, tokens } = JSON.parse(data);
            if (!platform || !tokens || typeof tokens !== 'object') {
                return;
            }
            if (typeof tokens.access_token !== 'string' ||
                typeof tokens.expiry_date !== 'number') {
                return;
            }
            const { access_token: accessToken, expiry_date: expiresAt } = tokens, extras = __rest(tokens, ["access_token", "expiry_date"]);
            analytics({
                action: 'PublishPlaform:Authorized',
                label: getPlatformTag(platform),
            });
            store.dispatch(publishSlice.actions.setAuthToken({
                platform,
                token: Object.assign(Object.assign({}, extras), { accessToken,
                    expiresAt }),
            }));
        }
        catch (_) {
            /* noop */
        }
        getLogger('broadcast', 'debug')(`${origin} says ${data}`);
    };
    return next => action => {
        next(action);
    };
};
